<template>
  <b-container>
    <SelectCard :profile="profile" :modal_only="true" ref="select_card" :action="update_plan" />

    <b-card-group deck>
      <b-card class="text-center">
        <template v-slot:header>
          <h6 class="mb-0">Small</h6>
        </template>
        <h3>£40 / month</h3>
        <p>10 directories per month</p>

        <LoadingButton v-if="site.monthly_citations != 10" type="submit" variant='primary' :loading="is_saving.small" @click="can_update_plan(10)">Upgrade</LoadingButton>
        <b-button v-else :disabled="true">Current Plan</b-button>
      </b-card>

      <b-card class="text-center">
        <template v-slot:header>
          <h6 class="mb-0">Large</h6>
        </template>
        <h3>£200 / month</h3>
        <p>50 directories per month</p>

        <LoadingButton v-if="site.monthly_citations != 50" type="submit" variant='primary' :loading="is_saving.large" @click="can_update_plan(50)">Upgrade</LoadingButton>
        <b-button v-else :disabled="true">Current Plan</b-button>
      </b-card>

    </b-card-group>
  </b-container>
</template>

<script>

import { db } from '@/main.js'
import api from '@/lib/api.js'
import SelectCard from '@/components/SelectCard.vue'

export default {
  name: 'site_links',
  props: ['site', 'profile'],
  components: {SelectCard},
  data() {
    return {
      is_saving: {
        small: false,
        large: false
      },
      monthly_citations: 0,
    }
  },
  methods: {
    can_update_plan(count) {
      this.monthly_citations = count
      if (this.profile.payment_method) {
        this.update_plan(count)
      } else {
        this.$refs.select_card.setup_billing()
        // Add a payment method, if successful then go here
      }
    },
    async update_plan(count) {
      let plan = 'small'
      if (count == 50) {
        plan = 'large'
      }

      this.is_saving[plan] = true
      await api.update_site_plan(this.$route.params.site_id, 'monthly_citations', this.monthly_citations)
      this.is_saving[plan] = false

      this.$bvToast.toast(`Plan updated`, {title: 'Saved', autoHideDelay: 2000, variant: 'success'})
    }
  },
  metaInfo() {
    return {
      title: `site links`
    };
  },
}
</script>

<style scoped>

</style>
